import { Component, OnInit, inject } from '@angular/core';
import { AdminVerifactuAuthorizationModel } from '../models/admin-verifactu-authorization.model';
import { AdminVerifactuService } from '../services/admin-verifactu.service';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfirmDialogComponent } from '../../../shared/components/dialogs/confirm-dialog/confirm-dialog.component';

@Component({
    selector: 'admin-verifactu-authorization',
    templateUrl: './admin-verifactu-authorization.component.html',
    styleUrls: ['./admin-verifactu-authorization.component.css'],
    standalone: false
})
export class AdminVerifactuAuthorizationComponent implements OnInit {
  activeTab = 'pending';
  authsPendings: AdminVerifactuAuthorizationModel[] = [];
  authsValidateds: AdminVerifactuAuthorizationModel[] = [];
  authsRevokeds: AdminVerifactuAuthorizationModel[] = [];
  loading = false;

  private readonly adminService = inject(AdminVerifactuService);
  private readonly verifactuService = inject(AdminVerifactuService);
  private readonly snackBar = inject(MatSnackBar);
  private readonly dialog = inject(MatDialog);

  ngOnInit(): void {
    this.getAll();
  }

  getAll(): void {
    this.loading = true;

    this.adminService.getAuthorization().subscribe({
      next: (data) => {
        this.loading = false;

        if (data.isSuccess) {
          this.authsValidateds = data.values.filter(
            (c) => c.validatedDate != null && c.revokedDate == null
          );
          this.authsPendings = data.values.filter(
            (c) => c.validatedDate == null && c.revokedDate == null
          );
          this.authsRevokeds = data.values.filter((c) => c.revokedDate != null);
        } else {
          this.snackBar.open(data.error.messages[0], 'Cerrar', { duration: 5000 });
        }
      },
      error: () => {
        this.loading = false;
        this.snackBar.open('No se pudo cargar la autorización.', 'Cerrar', {
          duration: 5000,
        });
      },
    });
  }

  getDocument(uid: string): void {
    this.loading = true;

    this.verifactuService.getDocumentAuthorization({ uid }).subscribe({
      next: (data) => {
        this.loading = false;

        if (data.isSuccess) {
          const link = document.createElement('a');
          link.href = `data:application/pdf;base64,${data.value.contentBase64}`;
          link.download = data.value.name || 'documento.pdf';
          link.click();
          this.snackBar.open('Documento descargado.', 'Cerrar', { duration: 3000 });
        } else {
          this.snackBar.open(data.error.messages[0], 'Cerrar', { duration: 5000 });
        }
      },
      error: () => {
        this.loading = false;
        this.snackBar.open('No se pudo descargar el documento.', 'Cerrar', {
          duration: 5000,
        });
      },
    });
  }

  onValidate(uid: string): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '350px',
      maxWidth: '96vw',
    });

    dialogRef.componentInstance.title = 'Validar autorización';
    dialogRef.componentInstance.message =
      '¿Estás seguro de que deseas validar la autorización?';

    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.loading = true;

        this.adminService.validateAuthorization({ uid }).subscribe({
          next: (data) => {
            this.loading = false;

            if (data.isSuccess) {
              this.snackBar.open('Autorización validada correctamente.', 'Cerrar', {
                duration: 4000,
              });
              this.getAll();
            } else {
              this.snackBar.open(data.error.messages[0], 'Cerrar', { duration: 5000 });
            }
          },
          error: () => {
            this.loading = false;
            this.snackBar.open('Error al validada la autorización.', 'Cerrar', {
              duration: 5000,
            });
          },
        });
      }
    });
  }

  onRevoke(uid: string): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '350px',
      maxWidth: '96vw',
    });

    dialogRef.componentInstance.title = 'Revocar autorización';
    dialogRef.componentInstance.message =
      '¿Estás seguro de que deseas revocar la autorización?';

    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.loading = true;

        this.adminService.revokeAuthorization({ uid }).subscribe({
          next: (data) => {
            this.loading = false;

            if (data.isSuccess) {
              this.snackBar.open('Autorización revocada correctamente.', 'Cerrar', {
                duration: 4000,
              });
              this.getAll();
            } else {
              this.snackBar.open(data.error.messages[0], 'Cerrar', { duration: 5000 });
            }
          },
          error: () => {
            this.loading = false;
            this.snackBar.open('Error al revocar la autorización.', 'Cerrar', {
              duration: 5000,
            });
          },
        });
      }
    });
  }
}